export default "__VITE_ASSET__b396a623__"